import { render, staticRenderFns } from "./VTemplateCreatorField.vue?vue&type=template&id=56bcf61f&scoped=true&"
import script from "./VTemplateCreatorField.vue?vue&type=script&lang=js&"
export * from "./VTemplateCreatorField.vue?vue&type=script&lang=js&"
import style0 from "./VTemplateCreatorField.vue?vue&type=style&index=0&id=56bcf61f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcf61f",
  null
  
)

export default component.exports